import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import CustomTable from "../../organisms/CustomTable";

const AddCreditsPopup = ({
  open,
  onCancel,
  onOk,
  selectedRowData,
  selectedColumns,
}) => {
  let bodyData;
  let headerData;
  const  [ credit ,  setCredit] =  useState(0)

  if (selectedRowData && selectedColumns) {
    bodyData = [selectedColumns.map((column) => selectedRowData[column])];
    headerData = selectedColumns;
  } else {
    bodyData = [];
    headerData = [];
  }

  useEffect(()=>{
    setCredit(0)
  },[open])

  const handleSubmit = () => {
    onOk({  projectId : selectedRowData["_id"], credit })
   
  }

  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={617}>
        <div>
          <h3 className="text-3xl px-10 font-bold">Add more Credits</h3>

          <div className="border-b-[1px] pt-4"></div>

          <div className="pt-2 text-left">
            <CustomTable data={bodyData} headerData={headerData} />
          </div>
          <div className="px-10 py-4">
            <label className="text-xl font-bold pr-6">Credits to Add</label>
            <Input
              type="number"
              variant="secondary"
              value={credit}
              onChange={(e) => setCredit(e.target.value)}
              className="inline-block w-36"
            />

            <div className="flex pt-10 justify-between">
              <Button
                varient="primary"
                color="blue"
                className="w-64 h-11 text-base py-2 text-white font-bold"
                onClick={handleSubmit}
              >
                Submit
              </Button>

              <Button
                varient="primary"
                borderColor={"blue"}
                color="white"
                onClick={onCancel}
                className="w-64 h-11 text-base text-blue-800 font-bold border-[1px]"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default AddCreditsPopup;
